module.exports = __webpack_public_path__ + "static/media/edit-project.8672b54c.svg";